export const withBackendService = () => process.env.REACT_APP_SERVICE_ENABLED === 'true';
export const toServiceUrl = (path) => {
    let url = `${process.env.REACT_APP_SERVICE_URL}${path}`;
    url = url.replace('%current.protocol%', `${window.location.protocol}`);
    url = url.replace('%current.port%', `${window.location.port}`);
    return url.replace('%current.hostname%', `${window.location.hostname}`);
};
